module.exports = __webpack_public_path__ + "15c7e24a3064b495bf1269cedef538a2.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/radio libertad.png
// module id = 620
// module chunks = 0